import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import * as moment from "moment";

@Component
class AttributeLabelValue extends Vue {
  @Prop({ default: null, type: [Object] })
  attribute: {
    id: number,
    name: string,
    unit: string,
    attribute_type: {
      id: number,
      name: string,
      type: string,
      calculable: boolean
    },
    attribute_value: {
      id: number,
      value: string | number | boolean
    }
  }

  @Prop({default: null})
  attrValue: string | number | boolean

  get lblSetting () {
    return {
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/agency-management').default,
      ...require('@/locales/button').default
    }
  }

  get coValue () {
    let val = null
    if (this.attrValue !== null && this.attrValue !== '' && this.attrValue !== undefined) {
      val = this.attrValue
    } else if (this.attribute.attribute_value && this.attribute.attribute_value.value !== null &&
      this.attribute.attribute_value.value !== '' && this.attribute.attribute_value.value !== undefined) {
      val = this.attribute.attribute_value.value
    } else return '-'
    if (this.attribute.attribute_type.type === 'boolean') return this.formatBoolean(val)
    if (this.attribute.attribute_type.type === 'date') return this.formatDate(val)
    return val
  }

  formatDate (date) {
    return moment(date).fromNow() + ' (' + moment(date).format('DD/MM/YYYY') + ')'
  }

  formatBoolean (val) {
    return val ? this.$t(this.lblSetting.amCalculableTrue) : this.$t(this.lblSetting.amCalculableFalse)
  }
}

export default AttributeLabelValue



// WEBPACK FOOTER //
// ./src/components/attribute-label-value/index.ts